<script setup></script>
<template>
  <span class="bg-[#FF6464] text-white rounded px-2 text-size"
    ><slot></slot
  ></span>
</template>
<style scoped>
.text-size {
  font-size: 0.65rem;
  line-height: 0.8rem;
}
</style>
